import {
    SET_CLIENT_VERSION,
    SET_CONFIGURATION,
    SET_ENVIRONMENT
} from '@/store/mutation.types';

export default {
    state: () => ({
        clientVersion: '0.1.0.0',
        environment: null,
        settings: null
    }),

    actions: {
        selectConfiguration: ({ commit }, {
            clientVersion, environment, settings
        }) => {
            if (clientVersion) {
                commit(SET_CLIENT_VERSION, clientVersion);
            }

            commit(SET_CONFIGURATION, settings);
            commit(SET_ENVIRONMENT, environment);
        }
    },

    mutations: {
        [SET_CLIENT_VERSION]: (state, clientVersion) => {
            state.clientVersion = clientVersion;
        },

        [SET_CONFIGURATION]: (state, settings) => {
            state.settings = settings;
        },

        [SET_ENVIRONMENT]: (state, environment) => {
            state.environment = environment;
        }
    }
};
